import { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

import Lenis from "@studio-freight/lenis";

import MouseFollower from "./components/MouseFollower";
import AboutMe from "./components/about/AboutMe";
import Connect from "./components/contact/Connect";
import Header from "./components/hero/Header";
import Loader from "./components/loader/Loader";
import Navbar from "./components/navbar/Navbar";
import WorkTabs from "./components/work/WorkTabs";
import ProjectsContextProvider from "./contexts/projectsContext";

export const lenis = new Lenis({
  duration: 1.2,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  wheelMultiplier: 1.5,
});

const raf = (time) => {
  lenis.raf(time);
  requestAnimationFrame(raf);
};

requestAnimationFrame(raf);

const App = () => {
  gsap.registerPlugin(ScrollTrigger);
  gsap.registerPlugin(ScrollToPlugin);

  useEffect(() => {
    lenis.stop();
    setTimeout(() => {
      lenis.start();
    }, 5000);
  }, []);

  return (
    <Router>
      <ProjectsContextProvider>
        <div className="App">
          <MouseFollower />
          <Loader />
          <Navbar />
          <Header />
          <AboutMe />
          <WorkTabs />
          <Connect />
        </div>
      </ProjectsContextProvider>
    </Router>
  );
};

export default App;
